import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Help } from "assets/question-mark.svg";
import { ReactComponent as LogoutIcon } from "assets/logout.svg";
import { IconWrapper, StyledTab as Tab, StyledTabs as Tabs } from "./styled";

interface IconTrayProps {
  setActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const getTab = (location: string): number | boolean => {
  switch (location) {
    case "/help":
      return 0;
    case "/logout":
      return 1;
    default:
      return false;
  }
};

const IconTray: React.FC<IconTrayProps> = ({ setActive }: IconTrayProps) => {
  const location = window.location.pathname;
  const [value, setValue] = useState<number | boolean>(false);

  useEffect(() => {
    const tab = getTab(location);
    if (!tab) {
      setActive(false);
    }
    setValue(tab);
  }, [location, setValue, setActive]);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number): void => {
    setActive(true);
    setValue(newValue);
  };

  return (
    <IconWrapper>
      <Tabs variant="fullWidth" value={value} onChange={handleChange} aria-label="icon tabs">
        <Tab component={Link} to="/help" icon={<Help />} />
        <Tab
          component={Link}
          to="/login"
          icon={<LogoutIcon />}
          onClick={() => {
            localStorage.removeItem("token");
          }}
        />
      </Tabs>
    </IconWrapper>
  );
};

export default IconTray;
